<ng-container *ngIf="attributes?.length">
  <ng-container *ngFor="let group of attributes; let i = index">
    <div class="my-12 overflow-hidden">
      <div
        class="typography typography-body typography-bold typography-paragraph grey-800"
        *ngIf="group.attributes?.length !== 1"
      >
        {{ group.title }}
      </div>

      <div class="grid grid-column grid-gutter-12">
        <div
          class="grid-item"
          *ngFor="
            let attribute of group.attributes;
            trackBy: trackByAttributeId
          "
        >
          <label class="grid align-item-center grid-gutter-16">
            <div class="grid-item grid-grow">
              <div class="typography typography-body grey-900">
                {{
                  group.attributes?.length === 1 ? group.title : attribute.name
                }}
              </div>
            </div>

            <div class="grid-item">
              <span class="checkbox">
                <input
                  type="checkbox"
                  id="attribute-{{ attribute.id }}"
                  class="checkbox-input"
                  [checked]="
                    (repository.selectedAttributes$ | async)?.includes(
                      attribute.id
                    )
                  "
                  (change)="toggleAttribute(attribute.id)"
                />
                <span class="checkbox-mark"></span>
              </span>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="divider"></div>
  </ng-container>
</ng-container>
